import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=3eb91b95&scoped=true&"
import script from "./Birthdays.vue?vue&type=script&lang=ts&"
export * from "./Birthdays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb91b95",
  null
  
)

export default component.exports